// 接口地址
export const listUrl = '/brand/getBrandList'
export const createUrl = '/brand/createBrand'
export const updateUrl = '/brand/updateBrand'
export const deleteUrl = '/brand/delete'

// 接口类型
export const TYPENUMBER = 1
